const selectors = {
  downloadsTab: '[data-downloads-tab]',
  downloadsGroup: '[data-downloads-group]',
};

class DownloadsNavigation extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('DOMContentLoaded', () => {
      this.downloadsTab = document.querySelector(selectors.downloadsTab);
      this.downloadsGroup = document.querySelector(selectors.downloadsGroup);
      this.downloadsTabAll = document.querySelectorAll(selectors.downloadsTab);
      this.downloadsGroupAll = [
        ...document.querySelectorAll(selectors.downloadsGroup),
      ];

      this.initTabs();
    });
  }

  initTabs() {
    this.downloadsGroup.classList.remove('hidden');
    this.downloadsTab.classList.add('font-bold', 'italic', 'underline');

    this.downloadsTabAll.forEach(item => {
      item.addEventListener('click', e => {
        e.preventDefault();

        this.downloadsTabAll.forEach(tab => {
          tab.classList.remove('font-bold', 'italic', 'underline');
        });

        item.classList.add('font-bold', 'italic', 'underline');

        this.downloadsGroupAll.forEach(current => {
          current.classList.remove('hidden');
          current.classList.remove('block');
          if (item.dataset.downloadsTab === current.dataset.downloadsGroup) {
            current.classList.add('block');
          } else {
            current.classList.add('hidden');
          }
        });
      });
    });
  }
}

customElements.define('downloads-navigation', DownloadsNavigation);
